<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap-title"><a id="page_iii"></a>Praise for <i>Holy Fire</i></h2>
<p class="noindentt">“A haunting and lyrical triumph.” —<i>Time</i></p>
<p class="noindentt">“Sterling is the best at seriously trying to predict future trends. In <i>Holy Fire</i> he has combined predictive talent with a sympathetic and complex heroine who can blend the old and the new.” —<i>The Denver Post</i></p>
<p class="noindentt">“A patented Sterling extra-special.” —<i>Newsday</i></p>
<p class="noindentt">“The social dimension is his bailiwick, and while Sterling has always had a sense of humor, particularly in his stories, he’s never written anything with the satirical zing and laff relief of the first 70 or so pages.” —<i>The Village Voice</i></p>
<p class="noindentt">“Science fiction that makes the rest of near-future SF look toylike in comparison. It’s as if Sterling is the only writer paying attention to what’s happening in the real world.” —<i>Locus</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Praise.vue?a71b0bbe